const userData = {
  firstName: "<Riad",
  lastName: "SAFI/>",
  title: "About Me",
  img: "/media/Riad.JPG",
  description:
    "Bienvenue! 👋 Passionné par les nouvelles technologies, la création de sites web modernes et base de données sécurisée, je suis actuellement en formation développeur web et application! 🚀 ",
};


const information = { userData };

export default information;
